import { render } from "./AddValueRestrictionComponent.vue?vue&type=template&id=98375588&scoped=true"
import script from "./AddValueRestrictionComponent.vue?vue&type=script&lang=js"
export * from "./AddValueRestrictionComponent.vue?vue&type=script&lang=js"

import "./AddValueRestrictionComponent.vue?vue&type=style&index=0&id=98375588&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98375588"]])

export default __exports__